import type React from 'react';
import { UserEnrollmentScheduleStatusIcon } from '../UserEnrollmentScheduleStatusIcon';
import styles from './index.module.scss';

type UserEnrollmentStatusProps = {
  scheduleStatus: string;
  scheduleStatusText: string;
  enrollmentCoursesLength: number;
  startDateText: string;
  endDateText: string;
};

export const UserEnrollmentStatus: React.FC<UserEnrollmentStatusProps> = ({
  scheduleStatus,
  scheduleStatusText,
  enrollmentCoursesLength,
  startDateText,
  endDateText,
}) => (
  <div className={styles.statusArea}>
    <UserEnrollmentScheduleStatusIcon
      scheduleStatus={scheduleStatus}
      scheduleStatusText={scheduleStatusText}
    />
    <p className={styles.coursesLength}>{enrollmentCoursesLength}科目</p>
    <p className={styles.term}>
      契約期間
      <span>
        {startDateText} ~ {endDateText}{' '}
      </span>
    </p>
  </div>
);
